import { render, staticRenderFns } from "./AssignmentsJudge.vue?vue&type=template&id=1a4e774d"
import script from "./AssignmentsJudge.vue?vue&type=script&lang=js"
export * from "./AssignmentsJudge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports